/*
 * Project: OKIT.VCM
 * 
 * Copyright 2023 by OKIT GmbH
 * All rights reserved.
 * 
 * Diese Software ist urheberrechtlich geschützt.
 */
import axios from "axios";
import apiList from "../utils/apiClient.js";

/**
 * This component implements the api's call
 * 
 * @author hatem sfar
 *
 */
const getNameSpaceListApi = async (id) => {
    const { data } = await axios.get(apiList.NodeDeviceList + id);
    return data;
}

const getAllNameSpacesApi = async () => {
    const { data } = await axios.get(apiList.NodeList);
    return data;
}

export {
    getNameSpaceListApi,
    getAllNameSpacesApi
}
